module.exports = __webpack_public_path__ + "img/h2.0ad6a200.png";